/** API route map: URLS.Controller.CareerPageSetting */
export const CareerPageSetting = {
      Name: 'CareerPageSetting/',
      AddCareerPageDisplayImage: 'add-career-page-display-image',
      PatchCareerPage: 'patch-career-page',
      GetCareerPage: 'get-career-page',
      GetCareerPageDisplayImages: 'career-page-display-images',
      UpdateCareerPageProfileImage: 'update-careerpage-profile-image',
      Delete: 'delete',
      DeleteBackground: 'delete-careerpage-background',
      AddDescription: 'add-description',
      addPrivacyTermsConditionDescription: 'add-privacy-terms-condition-description',
      addReferalTermsConditionDescription: 'add-referal-terms-condition-description',
      addAppTermsConditionDescription: 'add-App-terms-condition-description',
};
